import type { ButtonHTMLAttributes, ReactNode, Ref } from 'react';
import { glyphSize, iconButtonRecipe, iconSlot } from './IconButton.css';

export type IconButtonSize = 'xs' | 'sm' | 'md' | 'lg';
export type IconButtonTone = 'default' | 'danger';

/** IconButton props */
export interface IconButtonProps extends Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'children' | 'aria-label'
> {
  ref?: Ref<HTMLButtonElement>;
  /** 아이콘. 보조기술에서는 숨고 이름은 aria-label 이 든다 */
  icon: ReactNode;
  /** 글자 없는 버튼의 이름 — 필수 */
  'aria-label': string;
  /** 정사각 한 변 — xs 24 · sm 32 · md 40 · lg 48 */
  size?: IconButtonSize;
  /** danger 는 hover 에서만 붉어진다 (삭제·제거) */
  tone?: IconButtonTone;
}

export function IconButton({
  icon,
  size = 'sm',
  tone = 'default',
  // HTML 기본값 submit 은 form 안에서 표시 없이 폼을 제출한다 (Button 과 같은 이유).
  type = 'button',
  className,
  ref,
  ...props
}: IconButtonProps) {
  return (
    <button
      ref={ref}
      type={type}
      data-size={size}
      data-tone={tone === 'default' ? undefined : tone}
      className={`${iconButtonRecipe({ size, tone })}${className ? ` ${className}` : ''}`}
      {...props}
    >
      <span className={`${iconSlot} ${glyphSize[size]}`} aria-hidden="true">
        {icon}
      </span>
    </button>
  );
}
